module.exports = __webpack_public_path__ + "img/bao.6e316162.png";